import api from './client';

// BR OS (Bonjour Residences) API
export const brosAPI = {
  test: () => api.get('/bros/test'),
  getProperties: () => api.get('/bros/properties'),
  getBookings: (params) => api.get('/bros/bookings', { params }),
  getInvoices: (params) => api.get('/bros/invoices', { params }),
  getVatReserves: () => api.get('/bros/vat-reserves'),
  sync: () => api.post('/bros/sync'),
  importInvoices: () => api.post('/bros/import-invoices'),
};
